function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.5 3.491H7a.5.5 0 110 1H4.5v2.5a.5.5 0 01-1 0v-2.5H1a.5.5 0 010-1h2.5v-2.5a.5.5 0 011 0v2.5z",
  fill: "#2C3137",
  fillRule: "nonzero"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 8"
  }, props), _ref);
};

export default SvgComponent;